<div class="modal-header">
    <h3>{{ title }}</h3>
    <button mat-button (click)="onClose()" class="close-btn">Close</button>
</div>

<div class="modal-content">
    <p>{{ description }}</p>

    <!-- Chart Section-->
    <div class="chart-container">
        <div class="legend">
            <span> Seasonal % </span>
        </div>
        <p-chart type="line" [data]="chartData" [options]="chartOptions"></p-chart>
    </div>

    <!-- Table Section -->
    <div class="ag-grid-wrapper">
        <ag-grid-angular
            class="ag-theme-alpine"
            [columnDefs]="columnDefs"
            [rowData]="rowData"
            [gridOptions]="gridOptions"
        >
        </ag-grid-angular>
    </div>

    <div class="footer-note" *ngIf="kpiNote">
        {{ kpiNote }}
    </div>
</div>
